import {
  createApiFactory,
  createApiRef,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { avaliaDxHubBetsDemoPageRouteRef, rootRouteRef, teamsManagerPageRouteRef, homePage,  satisfactionTrackerPageRouteRef, teamSatisfactionDashboard, personalSatisfactionTracker} from './routes';
import { usersManagerPageRouteRef } from './routes';
import { EventApi } from './api/EventApi';
import { EventApiClient } from './api/EventApiClient';

export const eventApiRef = createApiRef<EventApi>({
  id: 'plugin.test.event',
});

export const SatisfactionPlugin = createPlugin({
  id: 'satisfaction-tracker',
  apis: [
    createApiFactory({
      api: eventApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new EventApiClient(discoveryApi, fetchApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});


export const AvaliaDxHubBetsDemoPage = SatisfactionPlugin.provide(
  createRoutableExtension({
    name: 'AvaliaDxHubBetsDemoPage',
    component: () =>
      import('./pages/AvaliaDxHubBetsDemoPage/AvaliaDxHubBetsDemoPage').then(
        m => m.AvaliaDxHubBetsDemoPage,
      ),
    mountPoint: avaliaDxHubBetsDemoPageRouteRef,
  }),
);

export const UsersManagerPage = SatisfactionPlugin.provide(
  createRoutableExtension({
    name: 'UsersManagerPage',
    component: () =>
      import('./pages/UsersManagerPage/UsersManagerPage').then(
        m => m.UsersManagerPage,
      ),
    mountPoint: usersManagerPageRouteRef,
  }),
);

export const TeamsManagerPage = SatisfactionPlugin.provide(
  createRoutableExtension({
    name: 'TeamsManagerPage',
    component: () => 
      import('./pages/TeamsManagerPage/TeamsManagerPage').then(
        m => m.TeamsManagerPage,
      ),
      mountPoint: teamsManagerPageRouteRef,

  })
)


export const SatisfactionTrackerPage = SatisfactionPlugin.provide(
  createRoutableExtension({
    name: 'SatisfactionTrackerPage',
    component: () => 
      import('./pages/SatisfactionTrackerPage/SatisfactionTrackerPage').then(
        m => m.SatisfactionTrackerPage,
      ),
      mountPoint: satisfactionTrackerPageRouteRef,

  })
)

export const TeamSatisfactionDashboard = SatisfactionPlugin.provide(
  createRoutableExtension({
    name: 'TeamSatisfactionDashboard',
    component: () => 
      import('./pages/TeamSatisfactionDashboard/TeamSatisfactionDashboard').then(
        m => m.TeamSatisfactionDashboard,
      ),
      mountPoint: teamSatisfactionDashboard,

  })
)
export const PersonalSatisfactionTracker = SatisfactionPlugin.provide(
  createRoutableExtension({
    name: 'PersonalSatisfactionTracker',
    component: () => 
      import('./pages/PersonalSatisfactionTracker/PersonalSatisfactionTracker').then(
        m => m.PersonalSatisfactionTracker,
      ),
      mountPoint: personalSatisfactionTracker,

  })
)


export const HomePage = SatisfactionPlugin.provide(
  createRoutableExtension({
    name: 'HomePage',
    component: () => 
      import('./pages/HomePage/HomePage').then(
        m => m.HomePage,
      ),
      mountPoint: homePage,

  })
)